<script>
import Star from "@/components/_base/Star";

import couponHelper from "@/utils/helpers/coupon";

import Badge from "./Badge";

export default {
  components: {
    Star,
    Badge
  },

  props: {
    professionalId: {
      type: String,
      required: true
    },
    profilePicture: {
      type: String,
      required: true
    },
    fullName: {
      type: String,
      required: true
    },
    orderCount: {
      type: Number,
      required: true
    },
    rating: {
      type: String,
      required: true
    },
    feedbacks: {
      type: Number,
      required: false
    },
    coupon: {
      type: Object,
      required: false,
      default: null
    },
    topProfessional: {
      type: Boolean,
      required: false,
      default: false
    },
    highDemand: {
      type: Boolean,
      required: false,
      default: false
    },
    sugestion: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    couponDiscount: function() {
      return couponHelper.getProfessionalCoupon(this.coupon);
    },

    totalOrderCount: function() {
      return this.orderCount;
    }
  }
};
</script>

<template>
  <div class="top" :class="{'top-sugestion': sugestion}" @click.stop="$emit('toogleProfile')">
    <img class="profile_picture" :src="profilePicture" />

    <div class="professional-info" :class="{ extra_margin: topProfessional || highDemand }">
      <p class="name">{{ fullName }}</p>

      <p class="orders">{{ totalOrderCount > 0 ? `${totalOrderCount} limpezas  realizadas` : 'Novo(a) profissional' }}</p>

      <div class="badges">
        <Badge iconPath="/static/shield.svg"  tooltipMessage="Profissional verificado" :sugestion="sugestion" />
        <Badge v-if='topProfessional' iconPath="/static/thumb-up.svg"  tooltipMessage="Profissional sugerido" :sugestion="sugestion" />
        <Badge v-if='highDemand' iconPath="/static/trending.svg"  tooltipMessage="Profissional em alta com agendamentos acima da média" :sugestion="sugestion" />
      </div>
    </div>

    <div class="rating">
      <Star />
      <div class="rating-number">
        {{ rating }} <span v-if="feedbacks > 3">({{ feedbacks ? feedbacks : '-' }})</span>
      </div>
    </div>

    <div class="discount" v-if="coupon">{{ couponDiscount }}</div>
  </div>
</template>

<style scoped>
.top {
  background-color: #f2f2f2;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-start;
  padding: 12px;
}

.top-sugestion {
  background-color: #9655d6;
  color: #fff;
}

.profile_picture {
  width: 80px;
  height: 80px;
  border-radius: 50px;
}

.professional-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 8px;
}

.extra_margin {
  margin-top: 8px;
}

.name {
  margin: 0;
  max-width: 80%;
  text-align: start;
  margin-top: 8px;
  font-weight: 400;
  text-align: start;
}

.orders {
  margin: 4px 0 0;
  font-size: 12px;
}

.feedbacks {
  margin: 4px 0 0;
  font-size: 12px;
  text-align: center;
}

.since {
  margin: 4px 0 0;
  font-size: 12px;
}

.since span {
  font-weight: 400;
}

.badges {
  margin-top: 8px;
  display: flex;
}

.rating {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
}

.rating .rating-number {
  margin-left: 4px;
  padding-left: 4px;
  display: flex;
  align-items: center;
  border-left: solid 1px #ddd;
}

.rating span {
  margin-left: 4px;
  font-size: 14px;
  font-weight: 300;
}

.rating .star {
  margin-bottom: 2px;
}

.discount {
  position: absolute;
  font-size: 12px;
  background: #424242;
  color: #fff;
  padding: 2px 16px 2px 8px;
  bottom: 12px;
  left: 0;
  bottom: 0;
  font-weight: 400;
}

.discount:before {
  content: "";
  width: 14px;
  height: 14px;
  position: absolute;
  right: -7px;
  background: #f2f2f2;
  transform: rotate(45deg);
}

@media (max-width: 350px) {
  .rating span {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalList/Card/Info.vue